import { apiClient, Auth } from '@/shared/api'

import { TUserMe } from '../model/schema'

export const getUserMe = async () => {
  const { data } = await apiClient.get<TUserMe>({
    endpoint: '/user/me',
    auth: Auth.REQUIRED,
  })

  return data
}
